export default () => ({
  initialized: false,
  configurationType: null,
  configurations: [],
  orderQuoteModalVisible: false,
  staticPages: [],
  companyInfo: {
    address: null,
    city: null,
    email: null,
    hours: null,
    logo: null,
    name: null,
    phone: null,
    social: {},
    url: null,
    zip: null,
    seo_title: null,
  },
  confirmModal: {
    visible: false,
    message: null,
    onConfirm: null,
  },
  configurationsSidebar: {
    open: false,
  },
  configurationSent: false
});
